import DialogEvaluacion from "@/components/DialogEvaluacion.vue";
const survey = {
    components: { DialogEvaluacion },
    data: () => ({
        encuestas: [],
        loadingSurvey: false,
        dialogEvaluar: false,
        selectedSurvey: null,
        answerSurvey: {
            encuesta_id: '',
            minuta_id: '',
            valor: null,
            cliente: '',
        }
    }),
    mounted() {
        this.fecthSurvey();
    },
    methods: {
        Encuesta1(survey) {
            this.selectedSurvey = survey;
            this.answerSurvey.valor = 0;
            this.answerSurvey.minuta_id = survey.id_minuta;
            this.answerSurvey.encuesta_id = survey.id;
            this.answerSurvey.cliente = this.$store.state.id;
            this.dialogEvaluar = true;
        },
        Encuesta(survey) {
            this.selectedSurvey = survey;
            this.dialogEvaluar = true;
        },
        fecthSurvey() {
            this.loadingSurvey = true;
            this.$axios.get('/survey', {
                params: {
                    id: this.$store.state.id
                }
            })
                .then(response => {
                    this.encuestas = response.data.information;
                    this.loadingSurvey = false;
                })
                .catch(error => {
                    console.log('Hubo un error en los datos');
                });
        },
        sendAnswer() {
            this.$axios.post('sendAnswer', this.answerSurvey)
                .then(response => {
                    this.resetSurvey();
                    this.fecthSurvey();
                })
                .catch(error => {
                    console.log('Hubo un error en los datos');
                });

        },
        resetSurvey() {
            this.selectedSurvey = '';
            this.answerSurvey = {
                encuesta_id: '',
                minuta_id: '',
                valor: null,
                cliente: '',
            }
            this.dialogEvaluar = false;
        },
        limitCaracters(text) {
            try {
                return JSON.stringify(text).slice(0, 250) + ' ...';
            } catch (error) {
                return text;
            }
        }
    }
}
export default survey;